// AI Coding
export const shareViaWhatsapp = (
  referralLink: string,
  brandName: string = "Lazyly",
) => {
  const message = `Hey! I've been loving the rewards at ${brandName}. Sign up with my link and you'll get an exclusive welcome gift right away! Grab it here: ${referralLink}`;
  const encodedMessage = encodeURIComponent(message);
  window.open(`https://wa.me/?text=${encodedMessage}`, "_blank");
};

export const shareViaEmail = (
  referralLink: string,
  brandName: string = "Lazyly",
) => {
  const subject = `A special welcome gift for you at ${brandName}!`;
  const body = `Hi there,\n\nI thought you'd love this. I've been using the ${brandName} program to earn points and get exclusive vouchers.\n\nIf you sign up using my invite link below, you'll instantly get a welcome gift to use on your first visit! 🎉\n\n👉 Claim your gift here: ${referralLink}\n\nSee you there!`;

  const encodedSubject = encodeURIComponent(subject);
  const encodedBody = encodeURIComponent(body);

  window.open(
    `mailto:?subject=${encodedSubject}&body=${encodedBody}`,
    "_blank",
  );
};
